$(function() {
  const $doc = $(document);
  
  $doc.on('click', '.Tab_item', onClickGroupMenu);
  $doc.on('click', '.SquareTab_item', onClickGenerationMenu);

  initGenerationMenu();
  initGenerationLinks();
  refresh();
});

var generationMenuListElement;
var generationLinks;

/**
 * Generationメニューの初期化
 */
function initGenerationMenu() {
  const $generationMenuWrap = $('#GenerationMenu');
  generationMenuListElement = $generationMenuWrap.find('ul.SquareTab_lists');

  for (var i = 1; i < generationMenuListElement.length; i++)
  {
    var className = '.' + $(generationMenuListElement[i]).attr('class').split(' ').join('.');
    $generationMenuWrap.find(className).hide();
  }
}

/**
 * Generationリンクの初期化
 */
function initGenerationLinks() {
  const $links = $('#MemberLinks').find('.member_link');
  generationLinks = [];

  for (var i = 0; i < $links.length; i++) {
    var $link = $($links[i]);
    var gr = Number($link.data('gr'));
    var ge = Number($link.data('ge'));
    var href = $link.attr('href');
    if (!$.isArray(generationLinks[gr])) generationLinks[gr] = [];
    generationLinks[gr][ge] = href;
  }

  $('#MemberLinks').remove();
}

/**
 * Groupメニュー選択
 */
function onClickGroupMenu() {
  $this = $(this);
  const $generationMenuWrap = $('#GenerationMenu');
  const selectIndex = Number($this.data('gr'));

  // Generationメニュー表示切替
  for (var i = 0; i < generationMenuListElement.length; i++) {
    var className = '.' + $(generationMenuListElement[i]).attr('class').split(' ').join('.');

    if (selectIndex == i) {
      $generationMenuWrap.find(className).show();
    } else {
      $generationMenuWrap.find(className).hide();
    }
  }

  // 初期選択
  $generationMenuWrap.find('ul.gr' + selectIndex).find('.SquareTab_item').first().trigger('click');
}

/**
 * Generationメニュー選択
 */
function onClickGenerationMenu() {
  refresh();
}

/**
 * 表示更新
 */
function refresh() {
  setMenberLink();
  setMemberMainImage();
  setMembers();
}

/**
 * グループのメイン画像設定
 */
function setMemberMainImage() {
  const groupIndex = Number(findActiveGroupMenuItem().data('gr') ?? 0);
  const generationIndex = Number(findActiveGenerationMenuItem().data('ge') ?? 0);

  $('.GenerationMainImage').hide();
  $('.GenerationMainImage.gr' + groupIndex + '.ge' + generationIndex).show();
}

/**
 * グループの商品一覧リンク設定
 */
function setMenberLink() {
  const groupIndex = Number(findActiveGroupMenuItem().data('gr') ?? 0);
  const generationIndex = Number(findActiveGenerationMenuItem().data('ge') ?? 0);

  if ($.isArray(generationLinks) && $.isArray(generationLinks[groupIndex]) && generationLinks[groupIndex][generationIndex]) {
    $('a.member_link').attr('href', generationLinks[groupIndex][generationIndex]);
  } else {
    $('a.member_link').attr('href', '#');
  }
}

/**
 * メンバー一覧の表示
 */
function setMembers() {
  const groupIndex = Number(findActiveGroupMenuItem().data('gr') ?? 0);
  const generationIndex = Number(findActiveGenerationMenuItem().data('ge') ?? 0);

  var showClass = '.gr' + groupIndex;
  showClass += '.ge' + generationIndex;
  
  $('.member_items .ItemTalent').hide();
  $('.member_items .ItemTalent' + showClass).show();
}

/**
 * 選択済Groupメニュー取得
 */
function findActiveGroupMenuItem() {
  return $('#GroupMenu').find('.Tab_item.isActive');
}

/**
 * 選択済Generationメニュー取得
 */
function findActiveGenerationMenuItem() {
  const activeGroupIndex = findActiveGroupMenuItem().data('gr');
  return $('#GenerationMenu').find('ul.gr' + activeGroupIndex).find('.SquareTab_item.isActive');
}